import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import logout from '../login/Logout';
import { tokenVerification } from './Utils';
class HealthSystemInfo extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
                showPwd: false,
                showCPwd: false,
                showOldPwd: false,
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteStaffDetail(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchStaffDetails()
                this.setState({ disabled: false })
            }
        }];

        const date = new Date();
        var minute = date.getMinutes();
        if (date.getMinutes() > 0 && date.getMinutes() < 10) {
            minute = '0' + date.getMinutes();
        }
        const showCurrentTime = date.getHours()
            + ':' + minute;

        this.state = {
            hiddenHealthSystemId: '',
            hiddenUserId: '',
            errors: {},
            showModel: false,
            editable: false,
            user_editable: false,
            error: '',
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            procedureDropDownValue: '',
            physicianId: '',
            selectedDate: new Date(),
            showEditBtn: false,
            patientName: '',
            patientEmailId: '',
            patientContactNumber: '',
            value: [],
            data: [{
                id: '',
                name: '',
                phoneNumber: '',
                emailId: ''
            }],
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            userRoleId: '',
            startTime: showCurrentTime
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            thisController.fetchHealthSystemDetails();
            thisController.fetchUserDetails();
        }, 300);


    }
    validateForm = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            errors["oldPassword"] = "*Please enter your old password";
        }

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    changePasswordApi = (e) => {
        let errors = {};
        var newPassword = document.getElementById("newPassword").value;
        var confirmPassword = document.getElementById("confirmPassword").value;

        if (document.getElementById("oldPassword").value == "") {
            errors["oldPassword"] = "*Please enter your old password";
            this.setState({errors: errors});
            // toast.dismiss();
            // toast(<b><img src="assets/images/warn.svg"
            //     style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            //     &nbsp;&nbsp;Please enter your old password too.</b>, {
                //     position: "top-center"
                // });     
            } else if (newPassword == ""  || (!newPassword.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/))) {
            errors["newPassword"] = "*Please enter secure and strong password.";
            this.setState({errors: errors});
            // toast.dismiss();
            // toast(<b><img src="assets/images/warn.svg"
            //     style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            //     &nbsp;&nbsp;Please enter secure and strong password.</b>, {
                //     position: "top-center"
                // });
            } else if(newPassword.length < 8 ){
            errors["newPassword"] = "*Please enter atleast 8 characters";
            this.setState({errors: errors});
            // toast.dismiss();
            // toast(<b><img src="assets/images/warn.svg"
            //     style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            //     &nbsp;&nbsp;Please use atleast 8 characters.</b>, {
            //     position: "top-center"
            // });
        } else if (newPassword != confirmPassword) {
            errors["confirmPassword"] = "*Passwords don't match";
            this.setState({errors: errors});
            // toast.dismiss();
            // toast(<b><img src="assets/images/warn.svg"
            //     style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            //     &nbsp;&nbsp;Passwords don't match.</b>, {
            //     position: "top-center"
            // });
        } else {
            e.preventDefault();
            if (this.validateForm()) {
                let myAccountController = this;
                let errors = {};
                let data = {
                    "emailId": JSON.parse(localStorage.getItem("user_details"))["emailId"],
                    "oldPassword": document.getElementById("oldPassword").value,
                    "newPassword": document.getElementById("newPassword").value
                }
                myAccountController.myFormRef.reset();
                $.ajax({
                    url: "/my-jeeva-api/change-password",
                    type: 'POST',
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json"
                    },
                    
                    data: JSON.stringify(data),
                    success: function (res) {
                        if (res.success === true) {
                            myAccountController.setState({ showStore: false });
                            myAccountController.notifyPasswordChanged();
                            setTimeout(() => {
                                logout();
                            }, 300);

                        } else {
                            myAccountController.setState({ disableOtp: true });
                            errors["response"] = res.result;
                            myAccountController.setState({
                                errors: errors
                            });
                        }
                    }
                });
            }
        }
    }
    fetchHealthSystemDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/fetch-current-health-system-details",
                
                method: 'GET',
                data: {
                    healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        fetchController.state.editable = false;
                     //   fetchController.state.user_editable = false;
                        document.getElementById('name').value = responseData.name;
                        document.getElementById('address').value = responseData.address;
                        document.getElementById('website').value = responseData.website;
                        fetchController.state.hiddenHealthSystemId = responseData.id;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.notifyFailedResponse(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                       tokenVerification();
                    }
                }
            }
        )

    }
    notifyUpdateToast() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Health System Details updated successfully
        </b>, {
            position: "top-center",
        });
    }
    updateHealthSystemDetailsApi = () => {
        var updateController = this;
        var name = document.getElementById('name').value.trim();
        var address = document.getElementById('address').value.trim();
        var website = document.getElementById('website').value.trim();
        // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

        var addressPattern = new RegExp(/^([a-zA-Z0-9 /''()#.,+-])*$/);
        var websitePattern = new RegExp(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/);

        if (name == "" || address == "" || website == "") {
            updateController.notifyEmptyFields();
        }
        else if (!namePattern.test(name)) {
            updateController.notifyImproperName();
        }
        else if (!addressPattern.test(address)) {
            updateController.notifyImproperAddress();
        }
        else if (!websitePattern.test(website)) {
            updateController.notifyImproperUrl();
        }
        else {
            var updatedData = {
                name: name,
                address: address,
                website: website,
                id: updateController.state.hiddenHealthSystemId
            };
            $.ajax({
                url: "/my-jeeva-api/update-health-system-acc-info",
                
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updateController.notifyUpdateDone();
                        updateController.fetchHealthSystemDetails();
                    } else {
                        updateController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            })
        }
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields before saving</b>, {
            position: "top-center"
        });
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyImproperAddress() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid address</b>, {
            position: "top-center"
        });
    }

    notifyImproperUrl() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid website URL</b>, {
            position: "top-center"
        });
    }

    fetchUserDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/fetch-my-info",
                
                method: 'GET',
                data: {
                    userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                      //  fetchController.state.editable = false;
                        fetchController.state.user_editable = false;
                        document.getElementById('user_name').value = responseData.userName;
                        document.getElementById('phonenumber').value = responseData.userPhoneNumber;
                        document.getElementById('emailId').value = responseData.userEmailId;
                        fetchController.state.hiddenUserId = responseData.id;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.notifyFailedResponse(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    updateUserApi = () => {

        var thisController = this;

        var adminName = document.getElementById("user_name").value.trim();
        var adminContactNumber = document.getElementById("phonenumber").value.trim();
        var adminEmailId = document.getElementById("emailId").value.trim();

        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/);
        //new RegExp(/^(?=.*\d).+$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        } 
        else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        }
        else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        } else {

            var saveData = {
                id: thisController.state.hiddenUserId,
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                userRole: "HEALTHSYSTEM_ADMIN",
                userEmailId: adminEmailId,
                userName: adminName,
                userPhoneNumber: adminContactNumber
            }
            $.ajax({
                url: "/my-jeeva-api/update-user-acc-info",
                
                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {
                        thisController.state.user_editable = true;
                        thisController.state.disabled = false;
                        thisController.notifyUserInfoUpdateDone();
                        thisController.fetchUserDetails();
                    } else {
                        if (res.result != "") {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.user_editable = false;
                        }
                        else {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.user_editable = false;
                        }
                    }
                    thisController.setState(thisController.state);
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    notifyUpdateDone() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System details updated</b>, {
            position: "top-center",

        });

    }
    notifyUserInfoUpdateDone() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Your information has been updated</b>, {
            position: "top-center",

        });

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyPasswordChanged() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Hurray! Your Password Changed Successfully</b>, {
            position: "top-center",

        });

    }


    handleChangeName = (e) => {
        this.state.patientEmailId = e.target.value;
        this.setState(this.state);

    }

    handleChangeDescription = (e) => {
        this.state.patientName = e.target.value;
        this.setState(this.state);
    }
    editValue = () => {
        this.state.user_editable = false;
        this.state.editable = true;
        this.setState(this.state);
    }
    editUserValue = () => {
        this.state.editable = false;
        this.state.user_editable = true;
        this.setState(this.state);
    }

    refreshHSData = () => {
        var thisController = this;
        thisController.fetchHealthSystemDetails();
    }

    refreshUserData = () => {
        var thisController = this;
        thisController.fetchUserDetails();
    }
    showChangePwd = () => {
        this.setState({ showModel: true });
    }
    closeChangePwd = () => {
        this.state.errors = {};
        this.setState(this.state);
        this.setState({ showModel: false });
        this.myFormRef.reset();
    }
    validateNewPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }
       var newPassword = document.getElementById("newPassword").value
        if (newPassword.length < 8) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter atleast 8 characters";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateConfirmPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateOldPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            formIsValid = false;
            errors["oldPassword"] = "*Please enter your old password";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    saveProfileUpdatedInfo() {
        //TO DO
    }

    showOldPassword = () => {
        if (this.state.showOldPwd) {
            this.setState({ showOldPwd: false });
        } else {
            this.setState({ showOldPwd: true });
        }
    }

    showPassword = () => {
        if (this.state.showPwd) {
            this.setState({ showPwd: false });
        } else {
            this.setState({ showPwd: true });
        }
    }

    showConfirmPassword = () => {
        if (this.state.showCPwd) {
            this.setState({ showCPwd: false });
        } else {
            this.setState({ showCPwd: true });
        }
    }

    oldPasswordResetInput = () =>{
        document.getElementById('oldPassword').value = '';
    }

    newPasswordResetInput = () =>{
        document.getElementById('newPassword').value = '';
    }

    confirmPasswordResetInput = () =>{
        document.getElementById('confirmPassword').value = '';
    }


    render() {
        return (
            <div id="healthSystemInfoTab" style={{ height: '700px' }}>
                <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* <ToastContainer className="Toast-at-center" /> */}

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h6 className="nav-item" style={{
                                        color: '#282a65',
                                        marginTop: '24px', marginLeft: '0.5vw'
                                    }}>Health System Information</h6>
                                </div>
                                {/* Add button and refresh button*/}
                                <div className="col-sm-6" Align='right'>

                                    <button className="btn action-button " style={{ marginLeft: '13px' }}
                                        title={this.state.editable ? "Save" : "Edit"}
                                        id="addMsg"
                                        onClick={this.state.editable ? this.updateHealthSystemDetailsApi : this.editValue}
                                    ><img src={this.state.editable ? this.saveImageSrc : this.editImageSrc} />
                                    </button>
                                    <button onClick={this.refreshHSData} className="btn action-button" title="Refresh" >
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className="card-body p-0 mb-25" style={{ marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">

                                    <div className='row' style={{ marginTop: '3vw' }}>
                                        <div className='col-sm-6'>
                                            <div className='col-sm-4' style={{ fontWeight: '500' }}>
                                                Health System Name
                                            </div>
                                            <div className='col-sm-1'>
                                                :
                                            </div>
                                            <div className='col-sm-7'>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="name" placeholder="Enter Name"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div className='col-sm-4' style={{ fontWeight: '500' }}>
                                                Address
                                            </div>
                                            <div className='col-sm-1'>
                                                :
                                            </div>
                                            <div className='col-sm-7'>
                                                <input
                                                    type="text" className="col-sm-8"
                                                    name="address" id="address" placeholder="Enter Address"
                                                    //value={this.state.fields.description}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: '2vw', marginBottom: '3vw' }}>
                                        <div className='col-sm-6'>
                                            <div className="col-sm-4" align="left"
                                                style={{ fontWeight: '500' }}>
                                                Website</div>
                                            <div className='col-sm-1'>:</div>
                                            <div className='col-sm-7'>
                                                <input
                                                    type="text" id="website" className="col-sm-8"
                                                    name="website" placeholder="Enter Website"
                                                    disabled={!this.state.editable}
                                                    //value={this.state.fields.supportPhoneNumber}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>


                                        </div>
                                        <div className='col-sm-6'></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '24px', marginLeft: '1vw'
                            }}>My Information</h6>
                        </div>
                        {/* Add button and refresh button*/}
                        <div className="col-sm-6" Align='right'>
                        
                            <button type="btn action-button" className="btn btn-primary"
                            style={{ width: "150px", fontSize: '14px' }} onClick={this.showChangePwd}>Change Password</button>

                            <button className="btn action-button " style={{ marginLeft: '13px' }}
                                title={this.state.user_editable ? "Save" : "Edit"} 
                                id="addMsg"
                                onClick={this.state.user_editable ? this.updateUserApi : this.editUserValue}
                            ><img src={this.state.user_editable ? this.saveImageSrc : this.editImageSrc} />
                            </button>
                            <button onClick={this.refreshUserData} className="btn action-button" title="Refresh" >
                                <img src="./assets/images/refresh_white_24dp.png"></img>
                            </button>
                        </div>

                    </div>
                    <div className="card-body p-0 mb-25" style={{ marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">

                                    <div className='row' style={{ marginTop: '3vw' }}>
                                        <div className='col-sm-6'>
                                            <div className='col-sm-4' style={{ fontWeight: '500' }}>
                                                Name
                                            </div>
                                            <div className='col-sm-1'>
                                                :
                                            </div>
                                            <div className='col-sm-7'>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="user_name" id="user_name" placeholder="Enter Name"
                                                    disabled={!this.state.user_editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div className='col-sm-4' style={{ fontWeight: '500' }}>
                                                Contact Number
                                            </div>
                                            <div className='col-sm-1'>
                                                :
                                            </div>
                                            <div className='col-sm-7'>
                                                <input className="col-sm-8"
                                                    type="text" id="phonenumber"
                                                    name="phonenumber" placeholder="Enter Mobile Number"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.user_editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: '2vw', marginBottom: '3vw' }}>
                                        <div className='col-sm-6'>
                                            <div className="col-sm-4" align="left"
                                                style={{ fontWeight: '500' }}>
                                                Email ID</div>
                                            <div className='col-sm-1'>:</div>
                                            <div className='col-sm-7'>
                                                <input
                                                    type="text" className="col-sm-8"
                                                    name="emailId" id="emailId" placeholder="Enter EmailId"
                                                    //value={this.state.fields.description}
                                                    disabled={true}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        textAlign: 'left',
                                                        borderBottom: "1px solid #ffffff"
                                                    }} />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'></div>
                                    </div>


                                    {/* <div className='row' style={{ height: '5vw' }}>
                                       
                                        <div className='col-sm-6'>

                                        </div>
                                    </div> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="modal" style={{ display: this.state.showModel ? 'block' : 'none' }}>
                            <div className="modal-dialog" id="center-aligned-password-modal">
                                <div className="modal-content" style={{ height: "auto", width: "830px" }}>
                                    <div className="modal-header noBorder" style={{ height: '39px' }}>
                                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeChangePwd}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={(el) => this.myFormRef = el}>
                                            <div className="input-group mb-3">
                                                <label className="col-sm-3 col-form-label">Old Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showOldPwd ? "text" : "password"} className="form-control sign-in- passinput" name="oldPassword"
                                                        style={{ width: '92%' }}
                                                        id="oldPassword" onBlur={this.validateOldPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter old password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showOldPassword}>{this.state.showOldPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.oldPasswordResetInput} id='resetInput'>Reset</button>
                                                </div>
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.oldPassword}</div>
                                            </div><br />


                                            <div className="input-group mb-3" style={{marginTop: '15px' }}>
                                                <label className="col-sm-3 col-form-label">New Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showPwd ? "text" : "password"} className="form-control sign-in- passinput" name="password"
                                                        style={{ width: '92%' }}
                                                        id="newPassword" onBlur={this.validateNewPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter new password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.newPasswordResetInput} id='resetInput'>Reset</button>
                                                </div>
                                                <span className="pNote" style={{ marginLeft: '1vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword}</div>
                                            </div>

                                            <div className="input-group mb-3" style={{marginTop: '30px' }}>
                                                <label className="col-sm-3 col-form-label">Confirm Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showCPwd ? "text" : "password"} className="form-control sign-in- passinput" name="confirmPassword"
                                                        style={{ width: '92%' }}
                                                        id="confirmPassword" onBlur={this.validateConfirmPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter confirm password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.confirmPasswordResetInput} id='resetInput'>Reset</button>
                                                </div>
                                                <span className="pNote" style={{ marginLeft: '1vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                <div className="errorMsg" style={{ color: 'red', marginTop: "-6.5rem" }}>{this.state.errors.confirmPassword}</div>
                                            </div><br />
                                            <div className="modal-footer noBorder">
                                                <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.changePasswordApi}>Done</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <ToastContainer className="Toast-at-center" />
                </div>

            </div>

        );
    }
}
export default HealthSystemInfo;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/HealthSystemInfo.js